require('../../assets/scripts/common/polyfills.js');
require('../../assets/lib/moment/moment-with-locales-2.29.4.min.js');
require('../../assets/lib/moment-timezone/moment-timezone-with-data-0.5.43.min.js');